import * as Yup from 'yup';

import { Column } from './types';

export function buildRowValidationSchema(columns: Column[]) {
  const shape: Record<string, Yup.AnySchema> = {};
  for (const col of columns) {
    if (col.validation) shape[col.id] = col.validation;
  }
  return Yup.object().shape(shape);
}

export function buildTableValidationSchema(columns: Column[]) {
  return Yup.array().of(buildRowValidationSchema(columns));
}

export function extractInvalidCells(err: Yup.ValidationError): Set<string> {
  const invalidCells = new Set<string>();

  err.inner.forEach((e) => {
    if (!e.path) return;

    // Custom component example (nested): "[1].custom_id.end_time"
    //eslint-disable-next-line no-useless-escape
    const match = e.path.match(/\[(\d+)\]\.([\w.]+)/);
    if (match) {
      const rowIndex = parseInt(match[1], 10);
      const columnId = match[2];
      invalidCells.add(`${rowIndex}.${columnId}`);
    } else {
      // fallback for simple errors (no nesting)
      invalidCells.add(e.path);
    }
  });

  return invalidCells;
}
